import React, { useContext } from 'react';
import {VisibilityContext} from "react-horizontal-scrolling-menu";

export const ScrollItem = ({children, itemId}) => {

    const visibility = useContext(VisibilityContext);
    const visible = visibility.isItemVisible(itemId);

    return (
        <>
            {children}
        </>
    )
}
